export interface Certificate {
  id: number;
  certificateNumber: string;
  certificateType: string;
  name: string;
  endDate: Date;
  balance: number;
  status: string;
}

export interface TruItem {
  truId: number;
  truName: string;
  code: string;
  maxQuantity?: number;
  maxAmount?: number;
  actQuantity?: number;
  actAmount?: number;
}

export enum TYPE_NAMES {
  'Покупка' = 'Покупка',
  'Возврат' = 'Возврат',
  'Частичный возврат' = 'Частичный возврат',
  'Возврат в бюджет' = 'Возврат в бюджет',
  'Корректировка положительная' = 'Корректировка положительная',
  'Корректировка отрицательная' = 'Корректировка отрицательная',
}

export interface TransactionItem {
  truName: string;
  typeName: TYPE_NAMES;
  dateTime: string;
  sellerDepartment: string;
  address: string;
  quantity: number;
  amount: number;
}

export interface CertificateAmountHistory {
  date: string;
  amountChange: number;
}

export interface CertificateInfo {
  certificateNumber: number;
  certificateTypeCode: string;
  templateName: string;
  startDate: string;
  endDate: string;
  actualAmount: number;
  statusName: string;
  actualQuantity?: number;
  organizationName: string;
  truBalance: TruItem[];
  transactions: TransactionItem[];
  amountHistories: CertificateAmountHistory[];
}

export interface Department {
  departmentId: number;
  sellerId: number;
  address: string;
  site: string;
  type: string;
  latitude: string;
  longitude: string;
  departmentTruAssignments: {
    sellerDepartmentId: number;
    truId: number;
  }[];
}

export interface Seller {
  fullName: string;
  name: string;
  brand: string;
  inn: string;
  kpp: string;
  departments: Omit<Department, 'departmentTruAssignments'>[];
}
